module.exports = __webpack_public_path__ + "img/2@2x.6d884b8e.png";